import { createReducer } from '@reduxjs/toolkit';
import { UNLOCK_PLAYER } from '../actions/AovivoBarActions';

const initialState = {
    locked: true,
};

const aovivoBar = createReducer(initialState, (builder) => {
    builder.addCase(UNLOCK_PLAYER, (state) => {
        state.locked = false;
    });
});

export default aovivoBar;
